import { AxiosError } from "axios";

interface ApiErrorData {
    message?: string;
    response?:
        | string
        | {
              errors?: string[] | Record<string, string[]>;
              exception?: string;
          };
}

const getFirstValidationMessage = (
    errors: string[] | Record<string, string[]>
): string | undefined => {
    if (Array.isArray(errors)) {
        const firstError = errors[0];
        return typeof firstError === "string" && firstError.trim().length > 0
            ? firstError
            : undefined;
    }

    const firstFieldErrors = Object.values(errors)[0];
    const firstError = firstFieldErrors?.[0];

    return typeof firstError === "string" && firstError.trim().length > 0
        ? firstError
        : undefined;
};

export const getApiErrorMessage = (
    error: unknown,
    fallback = "Ocorreu um erro inesperado."
): string => {
    if (!(error instanceof AxiosError)) {
        return fallback;
    }

    const data = error.response?.data as ApiErrorData | undefined;

    if (!data) {
        return fallback;
    }

    if (typeof data.message === "string" && data.message.trim().length > 0) {
        return data.message;
    }

    if (
        typeof data.response === "string" &&
        data.response.trim().length > 0
    ) {
        return data.response;
    }

    if (data.response && typeof data.response === "object") {
        if (data.response.errors) {
            const firstError = getFirstValidationMessage(data.response.errors);

            if (firstError) {
                return firstError;
            }
        }

        if (
            typeof data.response.exception === "string" &&
            data.response.exception.trim().length > 0
        ) {
            return data.response.exception;
        }
    }

    return fallback;
};
